import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-card-layout',
    templateUrl: './card-layout.component.html',
    styleUrls: ['./card-layout.component.scss'],
    standalone: false
})
export class CardLayoutComponent {
  @Input() public title: string;
  @Input() public disableHeaderSpacing = false;
}
